import { BrowserRouter, Route, Routes } from "react-router-dom";

import Experience from "./components/Experience";
import Tech from "./components/Tech";
import Works from "./components/Works";
import Feedbacks from "./components/Feedbacks";
import Contact from "./components/Contact";
import Hero from "./components/Hero";
import NavbarM from "./components/NavbarM";
import Whoami from "./components/Whoami";
import Cv from "./components/Cv";
import { StarsCanvas } from "./components/canvas";

const App = () => {
  return (
    <BrowserRouter>
      <div className="relative z-0 bg-primary">
        <NavbarM />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Tech />
                <Experience />
                {/* <Works /> */}
                <Feedbacks />
                {/* <StarsCanvas /> */}
              </>
            }
          />
          <Route path="/who-am-i" element={<Whoami />} />
          <Route
            path="/contact"
            element={
              <>
                <Contact />
                <StarsCanvas />
              </>
            }
          />
          <Route
            path="/cv"
            element={
              <>
                <Cv />
                {/* <StarsCanvas /> */}
              </>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
